<template>
  <div class="job-agent-widget bg-white p-8 rounded-3xl shadow-lg w-full">
    <div class="step-0 grid md:grid-cols-2 gap-8" v-show="step === 0">
      <div>
        <h2 class="mb-2">XING Job-Agent</h2>
        <span class="help-text">In 5 Schritten zum perfekten Job-Match</span>
        <img class="mt-16 hidden md:block" src="@/assets/images/ladder.svg" />
      </div>
      <div>
        <img
          class="w-48 h-48"
          style="margin-left: -40px"
          src="@/assets/images/eye-catcher-free-tool.svg"
        />
        <p class="mb-12">
          Beantworte uns ein paar Fragen zu Deinem Traumjob und wir listen Dir
          innerhalb einer Minute passende Job-Empfehlungen auf. Auf Wunsch
          schicken wir Dir zukünftige Ergebnisse direkt in Dein Postfach.
        </p>
        <div class="flex justify-end">
          <CallToActionButton
            bg-color="#00d296"
            text-color="#ffffff"
            :has-border="false"
            @clicked="goToNextStep(1)"
            >Jetzt starten</CallToActionButton
          >
        </div>
      </div>
    </div>
    <div v-show="step > 0">
      <div class="flex justify-end">
        <div
          class="flex items-center space-x-3 font-bold cursor-pointer"
          @click="goToNextStep(step - 1)"
        >
          <img src="@/assets/images/arrow-back.svg" />
          <span class="link-back">Back</span>
        </div>
      </div>
      <span class="progress-label font-bold">Frage {{ step }} von 5</span>
      <div class="progress-bar h-2 mt-2 mb-8 relative rounded-full">
        <div
          class="progress absolute top-0 left-0 h-2 rounded-full"
          :style="`width: ${(step / 5) * 100}%;`"
        >
          &nbsp;
        </div>
      </div>
      <div class="job-agent-survey flex flex-col justify-between h-full">
        <div class="step-1" v-show="step === 1">
          <h2 class="mb-2">Welches Karrierelevel möchtest Du erreichen?</h2>
          <span class="help-text"
            >Gib an, welches Level zu Dir passt oder welches Du anstrebst.</span
          >
          <form class="survey-form" @submit.prevent>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="1.795d28"
                value="1.795d28"
                v-model="surveyData.careerLevels"
              />
              <label for="1.795d28"
                >Student&bullet;in/Praktikant&bullet;in</label
              >
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="2.24d1f6"
                value="2.24d1f6"
                v-model="surveyData.careerLevels"
              />
              <label for="2.24d1f6">Berufseinsteiger&bullet;in</label>
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="3.2ebf16"
                value="3.2ebf16"
                v-model="surveyData.careerLevels"
              />
              <label for="3.2ebf16">Mit Berufserfahrung</label>
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="4.83b992"
                value="4.83b992"
                v-model="surveyData.careerLevels"
              />
              <label for="4.83b992"
                >Manager
                <span>(mit und ohne Personalverantwortung)</span></label
              >
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="5.6b837d"
                value="5.6b837d"
                v-model="surveyData.careerLevels"
              />
              <label for="5.6b837d"
                >Direktor&bullet;in
                <span>(Bereichsleitung, VP, SVP, etc.)</span></label
              >
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="6.37d32d"
                value="6.37d32d"
                v-model="surveyData.careerLevels"
              />
              <label for="6.37d32d"
                >Geschäftsführer&bullet;in <span>(GF, CEO, etc.)</span></label
              >
            </fieldset>
          </form>
        </div>
        <div class="step-2" v-show="step === 2">
          <h2 class="mb-2">Wo möchtest Du Arbeiten?</h2>
          <span class="help-text"
            >Suchst Du in einer bestimmten Stadt oder brauchst einen 100%
            standortunabhängigen Job?</span
          >
          <form class="survey-form" @submit.prevent>
            <fieldset class="location-fieldset">
              <input
                type="text"
                placeholder="Standort oder Stadt eingeben"
                v-model="surveyData.jobLocation"
              />
              <select v-model="surveyData.jobLocationRadius">
                <option value="0">Kein Umkreis</option>
                <option value="10">10 km</option>
                <option value="20">20 km</option>
                <option value="50">50 km</option>
                <option value="70">70 km</option>
                <option value="100">100 km</option>
                <option value="200">200 km</option>
              </select>
            </fieldset>
            <fieldset class="checkbox-fieldset mt-8">
              <input
                type="checkbox"
                id="is-remote"
                v-model="surveyData.isRemote"
              />
              <label for="is-remote"
                >100% Home-Office<br />
                <span class="help-text">Nur Remote Jobs anzeigen</span></label
              >
            </fieldset>
          </form>
        </div>
        <div class="step-3" v-show="step === 3">
          <h2 class="mb-2">In welcher Branche möchtest Du arbeiten?</h2>
          <span class="help-text"
            >Wähle Deine aktuelle oder zukünftige Branche aus.
          </span>
          <form class="survey-form" @submit.prevent>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="40000.944a62"
                value="40000.944a62"
                v-model="surveyData.jobIndustries"
              />
              <label for="40000.944a62">Industrie und Maschinenbau</label>
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="30000.9cc07c"
                value="30000.9cc07c"
                v-model="surveyData.jobIndustries"
              />
              <label for="30000.9cc07c">Automobil und Fahrzeugbau</label>
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="230000.83fcce"
                value="230000.83fcce"
                v-model="surveyData.jobIndustries"
              />
              <label for="230000.83fcce">Sonstige Branchen</label>
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="50000.df92c8"
                value="50000.df92c8"
                v-model="surveyData.jobIndustries"
              />
              <label for="50000.df92c8">Pharma und Medizintechnik</label>
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="20000.590ca2"
                value="20000.590ca2"
                v-model="surveyData.jobIndustries"
              />
              <label for="20000.590ca2">Konsumgüter und Handel</label>
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="190000.a611d3"
                value="190000.a611d3"
                v-model="surveyData.jobIndustries"
              />
              <label for="190000.a611d3"
                >Öffentlicher Dienst, Verbände und Einrichtungen</label
              >
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="210000.be2feb"
                value="210000.be2feb"
                v-model="surveyData.jobIndustries"
              />
              <label for="210000.be2feb">Gesundheit und Soziales</label>
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="41100.4999da"
                value="41100.4999da"
                v-model="surveyData.jobIndustries"
              />
              <label for="41100.4999da">Maschinenbau und Betriebstechnik</label>
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="160000.909d04"
                value="160000.909d04"
                v-model="surveyData.jobIndustries"
              />
              <label for="160000.909d04">Beratung und Consulting</label>
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="90000.597414"
                value="90000.597414"
                v-model="surveyData.jobIndustries"
              />
              <label for="90000.597414"
                >Internet und Informationstechnologie</label
              >
            </fieldset>
          </form>
        </div>
        <div class="step-4" v-show="step === 4">
          <h2 class="mb-2">
            Fast geschafft!<br />Wie lautet Deine Berufsbezeichnung?
          </h2>
          <span class="help-text"
            >Gib Deinen gewünschten Jobtitel oder ein bestimmtes Keyword
            an.</span
          >
          <form class="survey-form" @submit.prevent>
            <fieldset class="title-fieldset">
              <input
                type="text"
                placeholder="Jobtitel oder Keyword"
                v-model="surveyData.jobTitle"
              />
            </fieldset>
          </form>
        </div>
        <div class="step-5" v-show="step === 5">
          <h2 class="mb-2">In welchem Tätigkeitsfeld möchtest Du arbeiten?</h2>
          <span class="help-text"
            >Was ist Dein aktuelles Tätigkeitsfeld oder in welchem möchtest Du
            zukünftig arbeiten?
          </span>
          <form class="survey-form" @submit.prevent>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="1011.6cf3f7"
                value="1011.6cf3f7"
                v-model="surveyData.jobDisciplines"
              />
              <label for="1011.6cf3f7">IT und Softwareentwicklung</label>
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="1012.6ce534"
                value="1012.6ce534"
                v-model="surveyData.jobDisciplines"
              />
              <label for="1012.6ce534"
                >Management und Unternehmensentwicklung</label
              >
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="1005.6628c4"
                value="1005.6628c4"
                v-model="surveyData.jobDisciplines"
              />
              <label for="1005.6628c4"
                >Einkauf, Materialwirtschaft und Logistik</label
              >
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="1006.375e88"
                value="1006.375e88"
                v-model="surveyData.jobDisciplines"
              />
              <label for="1006.375e88"
                >Finanzen, Rechnungswesen und Controlling</label
              >
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="1013.2ed6ec"
                value="1013.2ed6ec"
                v-model="surveyData.jobDisciplines"
              />
              <label for="1013.2ed6ec">Marketing und Werbung</label>
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="1008.61ee6f"
                value="1008.61ee6f"
                v-model="surveyData.jobDisciplines"
              />
              <label for="1008.61ee6f">Gesundheit, Medizin und Soziales</label>
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="1009.76bd22"
                value="1009.76bd22"
                v-model="surveyData.jobDisciplines"
              />
              <label for="1009.76bd22">Grafik, Design und Architektur</label>
            </fieldset>
            <fieldset class="checkbox-fieldset">
              <input
                type="checkbox"
                id="1010.b48650"
                value="1010.b48650"
                v-model="surveyData.jobDisciplines"
              />
              <label for="1010.b48650"
                >Ingenieurwesen und technische Berufe</label
              >
            </fieldset>
          </form>
        </div>
        <div class="flex justify-end">
          <div>
            <div class="flex justify-end">
              <CallToActionButton
                style="min-width: 200px"
                bg-color="#00d296"
                text-color="#ffffff"
                :has-border="false"
                :is-disabled="!checkedCurrentStep"
                @clicked="goToNextStep(step + 1)"
                v-show="step < 5"
                >Weiter</CallToActionButton
              >
              <CallToActionButton
                bg-color="#00d296"
                text-color="#ffffff"
                :has-border="false"
                :is-disabled="!checkedCurrentStep"
                @clicked="showJobs"
                v-show="step === 5"
                >Ergebnisse anzeigen</CallToActionButton
              >
            </div>
            <div
              class="flex justify-center"
              v-show="
                (step === 1 || step === 3 || step === 4 || step === 5) &&
                !checkedCurrentStep
              "
            >
              <div class="flex items-center space-x-3 font-bold mt-2">
                <span class="required-fields-notice"
                  >Bitte triff erst eine Auswahl</span
                >
              </div>
            </div>
            <div class="flex justify-center" v-show="step === 2">
              <div
                class="flex items-center space-x-3 font-bold cursor-pointer mt-2"
                @click="skipSlide(2)"
              >
                <span class="link-skip-question">Frage überspringen</span>
                <img src="@/assets/images/arrow-next.svg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addTrackingParamToURL } from "@/utils/tracking.js";
import CallToActionButton from "./form/CallToActionButton.vue";
export default {
  name: "JobAgentWidget",
  components: { CallToActionButton },
  props: ["initialStep"],
  data() {
    return {
      step: this.initialStep || 0,
      surveyData: {
        // ?careerLevel=...&careerLevel=...
        careerLevels: [],
        // ?location=...
        jobLocation: "",
        // ?radius=...
        jobLocationRadius: 20,
        // ?benefit=1.795d28
        isRemote: false,
        // ?industry=...&industry=...
        jobIndustries: [],
        // ?keywords=...
        jobTitle: "",
        // ?discipline=...&discipline=...
        jobDisciplines: [],
      },
    };
  },
  computed: {
    checkedCurrentStep() {
      if (this.step === 1) {
        return this.surveyData.careerLevels.length > 0;
      } else if (this.step === 2) {
        return true;
      } else if (this.step === 3) {
        return this.surveyData.jobIndustries.length > 0;
      } else if (this.step === 4) {
        return this.surveyData.jobTitle !== "";
      } else if (this.step === 5) {
        return this.surveyData.jobDisciplines.length > 0;
      }
      return false;
    },
  },
  watch: {
    initialStep(val) {
      window.ttt.pageview(
        "wbm/Stellenmarkt",
        `wbm/Stellenmarkt/job_agent/questionnaire/step${val}`,
        {}
      );
      console.log(
        `pageview wbm/Stellenmarkt/job_agent/questionnaire/step${val}`
      );
      this.goToNextStep(val);
    },
  },
  methods: {
    getTrackingURL(url) {
      return addTrackingParamToURL(url);
    },
    skipSlide(currentStep) {
      if (currentStep === 2) {
        this.surveyData.jobLocation = "";
        this.surveyData.jobLocationRadius = 0;
        this.surveyData.isRemote = false;
      }

      this.goToNextStep(currentStep + 1);
    },
    goToNextStep(nextStep) {
      this.step = nextStep;
      this.$emit("changeStep", nextStep);
    },
    showJobs() {
      let url = this.getTrackingURL(
        "https://www.xing.com/jobs/search?sc_o=jobs_job_agent_questionnaire_complete"
      );

      try {
        url = new URL(url);

        for (const level of this.surveyData.careerLevels) {
          url.searchParams.append("careerLevel", level);
        }

        if (this.surveyData.jobLocation) {
          url.searchParams.append("location", this.surveyData.jobLocation);
        }

        if (this.surveyData.jobLocationRadius) {
          url.searchParams.append("radius", this.surveyData.jobLocationRadius);
        }

        if (this.surveyData.isRemote) {
          url.searchParams.append("benefit", "2.24d1f6");
        }

        for (const industry of this.surveyData.jobIndustries) {
          url.searchParams.append("industry", industry);
        }

        url.searchParams.append("keywords", this.surveyData.jobTitle);

        for (const discipline of this.surveyData.jobDisciplines) {
          url.searchParams.append("discipline", discipline);
        }
      } catch (err) {
        console.log(err);
      }

      window.location.href = url;
    },
  },
};
</script>

<style lang="scss">
.help-text {
  display: inline-block;
  color: #696f79;
}

.job-agent-survey {
  min-height: 650px;
}

.link-back {
  color: #8692a6;
}

.required-fields-notice,
.link-skip-question {
  @apply font-bold;
  color: #8692a6;
  font-size: 16px;
  line-height: 19px;
}

.progress-label {
  color: #5e737d;
  font-size: 14px;
  line-height: 17px;
}

.progress-bar {
  background-color: #f5f5f5;
}

.progress {
  background-color: #27dba8;
}

.survey-form {
  @apply my-8;
}

.step-3,
.step-5 {
  & .survey-form {
    max-height: 320px;
    overflow-y: auto;

    /* width */
    &::-webkit-scrollbar {
      width: 16px;
      height: 16px;
    }

    /* track */
    &::-webkit-scrollbar-track {
      border-radius: 100vh;
      background: #edf2f7;
    }

    /* handle */
    &::-webkit-scrollbar-thumb {
      background: #cbd5e0;
      border-radius: 100vh;
      border: 3px solid #edf2f7;
    }

    /* handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #a0aec0;
    }
  }
}

.step-2 {
  & .checkbox-fieldset {
    & label {
      font-size: 18px;
      line-height: 25px;
      max-width: 100%;

      & span {
        font-size: 18px;
        line-height: 25px;
      }
    }
  }
}

.location-fieldset {
  @apply flex flex-col space-y-4;

  & input[type="text"] {
    @apply px-4 py-2 w-full;
    border: 1px solid #bcc9d1;
    border-radius: 30px;
    color: #697d86;
    background-color: #f4f4f5;

    &::placeholder {
      color: #697d86;
    }
  }

  & select {
    @apply px-4 py-2 w-full;
    border: 1px solid #bcc9d1;
    border-radius: 30px;
    color: #697d86;
    background-color: #f4f4f5;
  }
}

.title-fieldset {
  & input[type="text"] {
    @apply px-4 py-2 w-full;
    border: 1px solid #bcc9d1;
    border-radius: 30px;
    color: #697d86;
    background-color: #f4f4f5;

    &::placeholder {
      color: #697d86;
    }
  }
}

.checkbox-fieldset {
  @apply flex items-center space-x-6 mb-4;

  & input[type="checkbox"] {
    accent-color: #27dba8;
    width: 20px;
    height: 20px;
  }

  & label {
    @apply font-bold;
    font-size: 18px;
    line-height: 25px;
    max-width: 300px;

    & span {
      font-weight: 400;
    }

    & .help-text {
      font-size: 18px;
      line-height: 25px;
    }
  }
}

@media (min-width: 640px) {
  .job-agent-survey {
    min-height: 550px;
  }

  .checkbox-fieldset {
    & input[type="checkbox"] {
      width: 40px;
      height: 40px;
    }

    & label {
      font-size: 23px;
      line-height: 28px;
      max-width: 100%;

      & .help-text {
        font-size: 20px;
        line-height: 24px;
      }
    }
  }
}

@media (min-width: 940px) {
  .job-agent-survey {
    min-width: 800px;
  }

  .location-fieldset {
    @apply flex flex-row space-y-0;
    max-width: 550px;

    & input[type="text"] {
      width: 66.7%;
      border-radius: 30px 0 0 30px;
    }

    & select {
      width: 33.3%;
      border-radius: 0 30px 30px 0;
    }
  }

  .title-fieldset {
    max-width: 550px;

    & input[type="text"] {
      width: 90%;
    }
  }
}
</style>
